<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.onu_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.onu_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Classificação de Risco
                      <i class="fa fa-user"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.onu_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 20%">Intruções de embalagem</th>
                                <th style="width: 15%">Provisões de embalagem</th>
                                <th style="width: 10%">Grupo de embalagem</th>
                                <th style="width: 10%">Quantidade limite de embalagem</th>
                                <th style="width: 10%">Quantidade limite veículo</th>
                                <th style="width: 20%">Intruções de tanque</th>
                                <th style="width: 15%">Provisões de tanque</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ rowData.embalagem_instrucoes}}
                                </td>
                                <td>
                                    {{ rowData.embalagem_provisoes}}
                                </td>
                                <td>
                                    {{ rowData.grupo_embalagem}}
                                </td>
                                <td>
                                    {{ rowData.quantidade_limite_embalagem_in}}
                                </td>
                                <td>
                                    {{ rowData.quantidade_limite_veiculo_kg}}
                                </td>
                                <td>
                                    {{ rowData.tanque_instrucoes}}
                                </td>
                                <td>
                                    {{ rowData.tanque_provisoes}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
				<div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.onu_id+''">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 50%">Código</th>
                                    <th style="width: 50%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td>
                                        {{ rowData.classe_risco.cd }}
                                    </td>
                                    <td>
                                      <span class="badge badge-success" v-if="rowData.classe_risco.status.valor==1">{{ rowData.classe_risco.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="rowData.classe_risco.status.valor==2">{{ rowData.classe_risco.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
  }
  </script>
